import { PurchaseEsimModule } from './../../front-end/purchase-esim/purchase-esim.module';
import { DashboardModule } from './../../front-end/dashboard/dashboard.module';
import { Routes } from '@angular/router';


export const content: Routes = [
  {
    path: 'dashboard',
    loadChildren: () => import('../../front-end/dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'plan',
    loadChildren: () => import('../../front-end/plan/plan.module').then(m => m.PlanModule)
  },
  {
    path: 'coupon',
    loadChildren: () => import('../../front-end/coupens/coupens.module').then(m => m.CoupensModule)
  },
  {
    path: 'order',
    loadChildren: () => import('../../front-end/orders/orders.module').then(m => m.OrdersModule)
  },
  {
    path: 'customer',
    loadChildren: () => import('../../front-end/customers/customers.module').then(m => m.CustomersModule)
  },
  {
    path: 'agents',
    loadChildren: () => import('../../front-end/agent/agent.module').then(m => m.AgentModule)
  },
  {
    path: 'contact',
    loadChildren: () => import('../../front-end/contact-details/contact-details.module').then(m => m.ContactDetailsModule)
  },
  {
    path: 'faq',
    loadChildren: () => import('../../front-end/faq/faq.module').then(m => m.FaqModule)
  },
  {
    path: 'setting',
    loadChildren: () => import('../../front-end/setting/setting.module').then(m => m.SettingModule)
  },
  {
    path: 'report',
    loadChildren: () => import('../../front-end/report/report.module').then(m => m.ReportModule)
  },
  {
    path: 'recharge-esim',
    loadChildren: () => import('../../front-end/recharge-esim/recharge-esim.module').then(m => m.RechargeEsimModule)
  },
  {
    path: 'activate-esim',
    loadChildren: () => import('../../front-end/activate-esim/activate-esim.module').then(m => m.ActivateEsimModule)
  },
  {
    path: 'role-permission',
    loadChildren: () => import('../../front-end/role-permission/role-permission.module').then(m => m.RolePermissionModule)
  },
  {
    path: 'purchase-esim',
    loadChildren: () => import('../../front-end/purchase-esim/purchase-esim.module').then(m => m.PurchaseEsimModule)
  }



];
